var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExchange = function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B176FF",
    d: "m10.55 9.333-1.92 1.921a.583.583 0 1 0 .824.825l2.917-2.917-.04-.016a.51.51 0 0 0 .21-.396c0-.322-.354-.583-.79-.583h-9.5c-.438 0-.792.26-.792.583s.354.583.791.583zM5.371 2.746l-1.92 1.92h8.3c.436 0 .79.262.79.584s-.354.583-.79.583h-9.5c-.438 0-.792-.26-.792-.583a.51.51 0 0 1 .21-.396l-.04-.016L4.546 1.92a.583.583 0 1 1 .825.825"
  })));
};
export default SvgExchange;